import { render } from "./GetAllEvaluations.vue?vue&type=template&id=4c70c217"
import script from "./GetAllEvaluations.vue?vue&type=script&lang=js"
export * from "./GetAllEvaluations.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__